import React, { FunctionComponent } from 'react';
import { useCss } from 'app/utils/css';
import { BaseColor, COLOR_PALETTE } from 'app/constants/ColorPalette';
import { FontWeight } from '../text/styles';
import { useHoverState } from '@engoo/react-hover-state';

interface IProps {
  clickable?: boolean;
  selected?: boolean;
  color?: BaseColor;
}

const Tag: FunctionComponent<IProps> = ({
  children,
  clickable = false,
  selected = false,
  color = BaseColor.Grey,
}) => {
  const css = useCss();
  const [isHovered, hoverRef] = useHoverState();
  const { base, dark, lighter } = COLOR_PALETTE[color];
  return (
    <div
      ref={hoverRef}
      className={css('tag', [
        {
          borderRadius: '4px',
          padding: '5px 10px 6px 10px',
          lineHeight: '1',
          fontSize: '11px',
          fontWeight: FontWeight.SemiBold,
          background: lighter,
          color: COLOR_PALETTE.grey.dark,
        },

        clickable && {
          padding: '4px 10px 7px 10px',
          boxShadow: `inset 0px -2px ${base}`,
        },

        clickable && isHovered && {
          background: base,
        },

        selected && {
          background: dark,
          boxShadow: '0 none',
          color: COLOR_PALETTE.grey.white,
        },
      ])}
    >
      {children}
    </div>
  );
};

export default Tag;
